import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function ServiceCharges({ children }) {
  useInjectSaga({ key: 'settingsServiceCharges', saga });
  useInjectReducer({ key: 'settingsServiceCharges', reducer });

  return React.Children.only(children);
}

ServiceCharges.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withSettingsServiceCharges } from './withSettingsServiceCharges';
export default compose(withConnect, memo)(ServiceCharges);
